import { Subject } from "rxjs";
import Cookies from "universal-cookie";

import PLAYLIST from "../constants/playlist";

const subject = new Subject();

const SETTINGSCOOKIE = "hoc_settings";
const DEFAULTSETTINGS = {
  currentVideoId: PLAYLIST[0]["videoId"],
  filterArtifacts: true,
  background: true,
  above: false,
  skipIntro: false,
};

const cookies = new Cookies();

const storedSettings = () => {
  if (!cookies.get(SETTINGSCOOKIE)) {
    cookies.set(SETTINGSCOOKIE, DEFAULTSETTINGS, {
      sameSite: "Lax",
      secure: true,
    });
  }
  return cookies.get(SETTINGSCOOKIE);
};

export const SettingsService = {
  updateSetting: (setting) => {
    cookies.set(
      SETTINGSCOOKIE,
      { ...storedSettings(), ...setting },
      { sameSite: "Lax", secure: true }
    );
  },
  sendSettings: (updatedSettings) => {
    cookies.set(
      SETTINGSCOOKIE,
      { ...storedSettings(), ...updatedSettings },
      { sameSite: "Lax", secure: true }
    );
    subject.next(storedSettings());
  },
  getSettings: () => {
    return storedSettings();
  },
  onSettings: () => subject.asObservable(),
  defaultSettings: () => {
    return DEFAULTSETTINGS;
  },
};

export default SettingsService;
